export default __webpack_public_path__ + "static/media/torso-mid-left-side.f6cb9a5c.png";